import React from 'react';

const InvoiceEmailModal = ({ state, setState, onClose, onSend }) => {
  if (!state.open) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Enviar factura por email</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {state.loading ? (
              <p>Cargando datos...</p>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label small">Destinatario *</label>
                  <input
                    className="form-control"
                    type="email"
                    value={state.to}
                    onChange={(e) => setState((prev) => ({ ...prev, to: e.target.value }))}
                    placeholder="cliente@ejemplo.com"
                  />
                  {!state.to && (
                    <div className="text-muted small mt-1">
                      El cliente no tiene email principal.
                      {state.clientId && (
                        <>
                          {' '}
                          <a href={'/clientes/' + state.clientId}>Editar cliente</a>
                        </>
                      )}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label small">Razón social</label>
                  <input className="form-control" value={state.clientName} disabled />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Nº de factura</label>
                  <input className="form-control" value={state.invoiceNumber} disabled />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Asunto *</label>
                  <input
                    className="form-control"
                    value={state.subject}
                    onChange={(e) => setState((prev) => ({ ...prev, subject: e.target.value }))}
                  />
                </div>
                <div className="mb-2">
                  <label className="form-label small">Mensaje</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={state.body}
                    onChange={(e) => setState((prev) => ({ ...prev, body: e.target.value }))}
                  />
                  <div className="text-muted small mt-1">La factura se adjunta en PDF automáticamente.</div>
                </div>
              </>
            )}
            {state.error && <div className="alert alert-danger py-2 mt-3">{state.error}</div>}
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
            <button
              className="btn btn-primary"
              disabled={state.loading || state.sending || !state.to.trim()}
              onClick={onSend}
            >
              {state.sending ? 'Enviando...' : 'Enviar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceEmailModal;
